import React, { Component as C } from "react"
import PerfectScrollbar from "perfect-scrollbar"
import i18n from "@cirrus/legacy/app-common/alt/framework/i18n.js"
import { selectionTypes } from "@cirrus/legacy/app-common/enums/selection-types.es6"
import StatelessCheckbox from "@cirrus/legacy/app-components/form-controls/checkboxes/stateless-checkbox/index.jsx"
import PropTypes from "prop-types"
import classNames from "classnames"

import styles from "./items.less"

class ElectFilterItems extends C {
  static propTypes = {
    className: PropTypes.string,
    items: PropTypes.array,
    onItemValueChanged: PropTypes.func,
    onChildItemValueChanged: PropTypes.func,
    dataQa: PropTypes.string,
    emptyText: PropTypes.string,
  }

  perfectScrollbar = null

  componentDidMount() {
    if (this._itemsList == null) {
      return
    }

    this.perfectScrollbar = new PerfectScrollbar(this._itemsList, this.getScrollbarOptions())
  }

  componentDidUpdate() {
    if (this._itemsList == null) {
      return
    }

    if (this.perfectScrollbar) {
      this.perfectScrollbar.update()
    } else {
      this.perfectScrollbar = new PerfectScrollbar(this._itemsList, this.getScrollbarOptions())
    }
  }

  componentWillUnmount() {
    if (this.perfectScrollbar && this._itemsList != null) {
      this.perfectScrollbar.destroy()
    }

    this.perfectScrollbar = null
  }

  getScrollbarOptions() {
    return {
      wheelPropagation: false,
    }
  }

  setItemsList = (element) => {
    if (this.perfectScrollbar && this._itemsList != null) {
      this.perfectScrollbar.destroy()
    }

    this.perfectScrollbar = null
    this._itemsList = element
  }

  render() {
    let {
      className,
      items,
      onItemValueChanged,
      onChildItemValueChanged,
      onChildItemsVisibilityChanged,
      dataQa,
      isSelectAllVisible,
      selectAllTitle,
      selectAllSelectionType,
      selectAllId,
      emptyText,
    } = this.props

    return (
      <div className={styles.listContainer}>
        {isSelectAllVisible && (
          <div className={styles.allItems}>
            <StatelessCheckbox
              label={selectAllTitle}
              onChange={() => {
                let isChecked
                if (selectAllSelectionType === selectionTypes.selected) {
                  isChecked = false
                } else if (selectAllSelectionType === selectionTypes.indeterminate) {
                  isChecked = true
                } else {
                  isChecked = true
                }

                onItemValueChanged(isChecked, selectAllId)
              }}
              isChecked={
                selectAllSelectionType === selectionTypes.selected ||
                selectAllSelectionType === selectionTypes.indeterminate
              }
              checkedLabelClassName={styles.labelCheckbox}
              className={classNames(styles.item, {
                [styles.indeterminate]: selectAllSelectionType === selectionTypes.indeterminate,
              })}
            />
          </div>
        )}
        <div ref={this.setItemsList} className={classNames(styles.list, className)}>
          <div data-qa={dataQa}>
            {items.map((i) => (
              <div key={i.id} className={styles.itemContainer}>
                <StatelessCheckbox
                  label={i.title}
                  onChange={() => {
                    let isChecked
                    if (i.selectionType === selectionTypes.selected) {
                      isChecked = false
                    } else if (i.selectionType === selectionTypes.indeterminate) {
                      isChecked = true
                    } else {
                      isChecked = true
                    }

                    onItemValueChanged(isChecked, i.id)
                  }}
                  isChecked={
                    i.selectionType === selectionTypes.selected ||
                    i.selectionType === selectionTypes.indeterminate
                  }
                  checkedLabelClassName={styles.labelCheckbox}
                  className={classNames(
                    styles.item,
                    i.selectionType === selectionTypes.indeterminate ? styles.indeterminate : null,
                    i.children && i.children.length > 0 && i.childrenExpanded
                      ? styles.expanded
                      : null,
                  )}
                />
                {i.children && i.children.length > 0 && (
                  <div
                    className={styles.caretContainer}
                    data-qa="extend-list"
                    onClick={() => onChildItemsVisibilityChanged(!i.childrenExpanded, i.id)}>
                    <span
                      className={classNames(styles.caret, {
                        [styles.caretUp]: i.childrenExpanded,
                        [styles.caretDown]: !i.childrenExpanded,
                      })}
                    />
                  </div>
                )}
                {i.children && i.children.length > 0 && i.childrenExpanded && (
                  <div className={styles.childItems}>
                    {i.children.map((child) => (
                      <div key={child.id} className={styles.itemContainer}>
                        <StatelessCheckbox
                          label={child.title}
                          onChange={() => onChildItemValueChanged(!child.isSelected, child.id)}
                          checkedLabelClassName={styles.labelCheckbox}
                          isChecked={child.isSelected}
                          className={styles.item}
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
            {items.length === 0 && (
              <span className={styles.empty}>
                {emptyText ? emptyText : i18n("General:NoItems")}
              </span>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default ElectFilterItems
